// assets/scroll-depth.js
(function(){
  let maxPercent = 0;

  // Recalculate and record current scroll depth on every scroll
  function recordDepth() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const docHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight
    ) - window.innerHeight;
    if (docHeight <= 0) return;

    const pct = (scrollTop / docHeight) * 100;
    if (pct > maxPercent) {
      maxPercent = pct;
    }
  }

  // Decide which bucket to fire
  function fireScrollEvent() {
    const pctRounded = Math.round(maxPercent);
    let name;
    if      (pctRounded >= 90) name = 'Scrolled 90%';
    else if (pctRounded >= 50) name = 'Scrolled 50%';
    else if (pctRounded >= 5)  name = 'Scrolled 5%';
    else                       name = 'Scrolled 0%';

    console.log(`[ScrollDepth] firing event: ${name} with pct: ${pctRounded}%`);

    if (window.heap && typeof heap.track === 'function') {
      heap.track(name, {
        url: window.location.pathname,
        scroll_pct: pctRounded
      });
    }
  }

  // Listen continuously
  window.addEventListener('scroll', recordDepth, { passive: true });
  // Fire on unload or when user leaves tab
  window.addEventListener('beforeunload', fireScrollEvent);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      fireScrollEvent();
    }
  });
})();
